package pl.decks.personal.pages.ievp.sections.background

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.percent

enum class BackgroundEntry(
    val title: String,
    val flavorText: String,
    val proofs: List<Proof>,
    val icon: @Composable () -> Unit,
) {
    MATHEMATICIAN(
        title = "Mathematician",
        flavorText = "Born as one. " +
                "It makes the world a wonder riddle with an always-escaping solution. " +
                "Yet, there is no bigger joy than chasing one. " +
                "Numbers is how I perceive. " +
                "They let me find the wildest ideas and contradict them.",
        proofs = listOf(
            Proof(
                icon = { FaGraduationCap() },
                what = "M.Sc. in Applied Mathematics",
                where = "University of Science and Technology",
                description = "Thesis: Substructure analysis and classification in graphs (application in metabolic pathways)",
                timeSpan = "Feb 2019 - Jun 2020",
                location = "Wrocław, Poland",
            ),
            Proof(
                icon = { FaScroll() },
                what = "Publication",
                where = "Chaos: An Interdisciplinary Journal of Nonlinear Science (2021, vol 31, issue 4)",
                description = "Title: Stochastic modeling of Lévy-like human eye movements",
            ),
            Proof(
                icon = { FaGraduationCap() },
                what = "B.Sc. in Applied Mathematics",
                where = "University of Science and Technology",
                description = "Thesis: Lévy walks applications in the modeling of eye movement",
                timeSpan = "Oct 2015 - Feb 2019",
                location = "Wrocław, Poland",
            )
        ),
        icon = { SpanText("π", modifier = Modifier.translateY((-8).percent)) },
    ),
    WRITER(
        title = "Writer",
        flavorText = "If numbers are how I see the world, word and story are how I've reasoned about it since I learned my first few. " +
                "Writing, like no other form, demands concision and precision to convey a thought and yet somehow leaves space for beauty. " +
                "The most vulnerable of identities, it feels private - and I guarded it from the outside world for years. " +
                "Deep down, it is neither a newfound lemma nor a successful company that my heart yearns for most. " +
                "There are stories and characters, sprouting. " +
                "Deserving to be born into a novel.",
        proofs = listOf(),
        icon = { FaPen() },
    ),
    FOUNDER(
        title = "Founder",
        flavorText = "The newest of identities and I am still internalizing how it affects me. " +
                "It's like a new pair of lenses, which allow me to ask the right questions and answer them. " +
                "Previously, a lot of things did not fit, seemed purposeless, sometimes even annoyingly stupid. " +
                "Now, I can't stop catching myself thinking \"that's just a clever part of a business model\".",
        proofs = listOf(
            Proof(
                icon = { FaTrophy() },
                what = "Award winner",
                where = "MCSC Hospital Leadership Innovation",
                timeSpan = "Dec 2025",
                location = "Poland",
            ),
            Proof(
                icon = { FaTrophy() },
                what = "Finalist",
                where = "Unicorn Hub Startup Booster",
                timeSpan = "Mar 2025",
                location = "Poland",
            ),
            Proof(
                icon = { FaRocket() },
                what = "Started a company",
                where = "Exura",
                timeSpan = "Dec 2023",
                location = "Poland",
            ),
        ),
        icon = { FaRocket() },
    ),
    ;

    val revealSteps = 2 + proofs.size

    data class Proof(
        val icon: (@Composable () -> Unit) = {},
        val what: String,
        val where: String,
        val timeSpan: String? = null,
        val location: String? = null,
        val description: String? = null,
    )
}
